import React, { useEffect } from "react";
import { AuthProvider } from "./components/context/API_Client";
import RouteManager from "./RouteManager";
import { ToastContainer } from "react-toastify";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, ArcElement } from 'chart.js';
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, ArcElement);

function App() {

  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastContainer />
        <RouteManager />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
